// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__baeeG","rootMobile":"styles_rootMobile__20ZY3"};